import * as React from 'react'
import { SVGProps } from 'react'
const SvgReturnOrder2 = (props: SVGProps<SVGSVGElement>) => (
  <svg width={28} height={27} viewBox="0 0 28 27" fill="none" {...props}>
    <path
      d="M21.54 20.69H7.169V6.322h14.37v14.37ZM8.179 19.683H20.53V7.33H8.179v12.352Z"
      fill="#4E4E4E"
    />
    <path
      d="M15.953 7.33v5.07l-1.77-1.496-1.77 1.496V7.33h3.54ZM11.896 18.152H8.813v1.009h3.083v-1.009ZM11.002 16.516h-2.19v1.009h2.19v-1.01ZM19.895 17.077h-1.97v1.97h1.97v-1.97Z"
      fill="#4E4E4E"
    />
    <path
      d="M1.119 16.955C.729 15.322.084 11.07 2.525 6.848 4.88 2.778 9.241.194 13.91.104c4.016-.078 7.838 1.644 10.487 4.723l-.765.658c-2.452-2.85-5.99-4.442-9.702-4.373-4.317.084-8.352 2.475-10.53 6.241-2.26 3.907-1.66 7.853-1.299 9.368l-.98.234h-.001Z"
      fill="#4E4E4E"
    />
    <path
      d="m21.972 5.144 1.692-.392.89-1.49.941 4.002-3.523-2.12ZM13.768 26.965c-3.695-.095-7.192-1.715-9.705-4.52l.752-.673c2.508 2.802 6.075 4.326 9.787 4.18 4.315-.17 8.302-2.64 10.405-6.447 2.183-3.95 1.506-7.884 1.113-9.391l.977-.255c.422 1.626 1.15 5.864-1.206 10.134-2.273 4.114-6.584 6.784-11.249 6.966-.291.012-.583.014-.873.006h-.001Z"
      fill="#4E4E4E"
    />
    <path
      d="m6.48 22.08-1.683.425-.862 1.508-1.019-3.984 3.564 2.05Z"
      fill="#4E4E4E"
    />
  </svg>
)
export default SvgReturnOrder2
